import { render } from "./edit.profile.vue?vue&type=template&id=36c66277"
import script from "./edit.profile.vue?vue&type=script&lang=js"
export * from "./edit.profile.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__